import { PlanDefinition } from "@medplum/fhirtypes";

import { ChecklistTemplateTableDataType } from "@/types/checklist-template";

export const parsePlanDefinitionToChecklistTemplateTableData = (
  planDefinition: PlanDefinition[],
): ChecklistTemplateTableDataType[] => {
  if (!planDefinition.length) return [];

  return planDefinition.map((planDefinition) => ({
    id: planDefinition.id!,
    templateName: planDefinition.title || "",
    tasks: planDefinition.action?.length || 0,
    createdBy: planDefinition.meta?.author?.display || "",
    shareSettings: planDefinition.useContext?.[0]?.valueCodeableConcept?.coding?.[0]?.code || "",
  }));
};
